import { addAttachmentAtomType } from './addAttachmentAtomType';
/**
 * Adds an attachment for a certain atom type to a correlation.
 *
 * @param {Correlation} correlation
 * @param {string} atomType
 * @param {number} attachment
 */
export function addAttachment(correlation, atomType, attachment) {
    addAttachmentAtomType(correlation, atomType);
    if (!correlation.attachment[atomType].includes(attachment)) {
        correlation.attachment[atomType].push(attachment);
    }
    return correlation;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWRkQXR0YWNobWVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlsaXRpZXMvY29ycmVsYXRpb24vYWRkQXR0YWNobWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxPQUFPLEVBQUUscUJBQXFCLEVBQUUsTUFBTSx5QkFBeUIsQ0FBQztBQUVoRTs7Ozs7O0dBTUc7QUFDSCxNQUFNLFVBQVUsYUFBYSxDQUMzQixXQUF3QixFQUN4QixRQUFnQixFQUNoQixVQUFrQjtJQUVsQixxQkFBcUIsQ0FBQyxXQUFXLEVBQUUsUUFBUSxDQUFDLENBQUM7SUFDN0MsSUFBSSxDQUFDLFdBQVcsQ0FBQyxVQUFVLENBQUMsUUFBUSxDQUFDLENBQUMsUUFBUSxDQUFDLFVBQVUsQ0FBQyxFQUFFO1FBQzFELFdBQVcsQ0FBQyxVQUFVLENBQUMsUUFBUSxDQUFDLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQyxDQUFDO0tBQ25EO0lBRUQsT0FBTyxXQUFXLENBQUM7QUFDckIsQ0FBQyJ9